import { useEffect, useState } from "react";
import { Button } from "@material-tailwind/react";

function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
}

const TimePane = ({ availableAt, canClaim = true, claiming = false, onClaim }) => {
    const [parts, setParts] = useState({ day: '00', hour: '00', min: '00', sec: '00' });
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const target = availableAt ? new Date(availableAt).getTime() : Date.now();

        const tick = () => {
            const diff = Math.max(0, target - Date.now());
            const day = Math.floor(diff / 86400000);
            const hour = Math.floor((diff % 86400000) / 3600000);
            const min = Math.floor((diff % 3600000) / 60000);
            const sec = Math.floor((diff % 60000) / 1000);
            setParts({
                day: pad(day),
                hour: pad(hour),
                min: pad(min),
                sec: pad(sec),
            });
            setIsReady(diff <= 0);
        };

        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [availableAt]);

    const cells = [
        { value: parts.day, label: 'Day' },
        { value: parts.hour, label: 'Hour' },
        { value: parts.min, label: 'Min' },
        { value: parts.sec, label: 'Sec' },
    ];

    const showClaim = isReady && canClaim;

    return (
        <div className="flex w-full p-[60px] items-center justify-center">
            <div className="flex flex-col bg-bg rounded-[20px] w-[383px] py-3 px-[24px]">
                <div className="flex justify-center">
                    <p className="text-white text-[16px] font-Inter-Regular font-[500]">
                        {showClaim ? 'Claim is now available' : 'Claim Available in'}
                    </p>
                </div>
                <div className="flex flex-col mt-6 gap-2 px-[16px]">
                    <div className="flex flex-row justify-center">
                        {cells.map((cell, index) => (
                            <div key={cell.label} className="flex flex-row">
                                <div className="flex flex-col justify-center items-center gap-2">
                                    <div className="flex w-[60px] h-[60px] font-Inter-Regular rounded-[8px] bg-[#111] items-center justify-center text-white font-[600] text-[24px]">
                                        {cell.value}
                                    </div>
                                    <span className="font-Inter-Regular text-gray1 text-[14px] font-[500] uppercase">{cell.label}</span>
                                </div>
                                {index < cells.length - 1 && (
                                    <div className="flex flex-col h-full gap-4 pt-4 px-1 justify-between">
                                        <span className="rounded-full w-[5px] h-[5px] bg-gray1"></span>
                                        <span className="rounded-full w-[5px] h-[5px] bg-gray1"></span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                {showClaim && (
                    <div className="flex justify-center mt-6 mb-2">
                        <Button
                            className="bg-[#FBBF04] text-black text-[14px] font-semibold rounded-[30px] px-[48px] py-[12px] shadow-none hover:shadow-none normal-case"
                            onClick={onClaim}
                            disabled={claiming}
                        >
                            {claiming ? 'Claiming...' : 'Claim'}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TimePane;
